import { render } from "./departmentManage.vue?vue&type=template&id=1a335671&scoped=true"
import script from "./departmentManage.vue?vue&type=script&lang=js"
export * from "./departmentManage.vue?vue&type=script&lang=js"

import "./departmentManage.vue?vue&type=style&index=0&id=1a335671&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a335671"]])

export default __exports__